// The rated bot pool (exported by packages/core/tools/bots/export.mjs): every
// entry is a fixed personality with a measured Elo (mixed 1v1 / 4-worm rounds,
// internal scale, median ~1500), so "a 1600 bot" means something. Used by the
// bots playground (/debug/bots) to seat and inspect rated bots.
import poolJson from "core/src/ai/bot-pool.json";

export interface PoolBot { id: string; elo: number; rounds?: number; winRate?: number; traits: Record<string, number> }
export const BOT_POOL: PoolBot[] = poolJson as PoolBot[];
export const POOL_ELO_MIN = BOT_POOL.length ? BOT_POOL[0].elo : 1000;
export const POOL_ELO_MAX = BOT_POOL.length ? BOT_POOL[BOT_POOL.length - 1].elo : 2000;

// A random pool bot near the target Elo (within +-60, widening until one is
// found), avoiding ids already in use so a roster gets distinct personalities.
export function pickPoolBot(targetElo: number, usedIds: Set<string> = new Set()): PoolBot | null {
  if (!BOT_POOL.length) return null;
  for (let width = 60; width <= 2000; width *= 2) {
    const cands = BOT_POOL.filter((b) => Math.abs(b.elo - targetElo) <= width && !usedIds.has(b.id));
    if (cands.length) return cands[Math.floor(Math.random() * cands.length)];
  }
  return BOT_POOL[Math.floor(Math.random() * BOT_POOL.length)];
}

// One-word persona hint from the strongest personality trait, for a name.
export function personaWord(traits: Record<string, number>): string {
  const words: Record<string, [string, string]> = {
    caution: ["Daredevil", "Careful"], aggression: ["Coward", "Hunter"],
    space: ["Hermit", "Explorer"], greed: ["Ascetic", "Greedy"],
  };
  let best = "", bestV = 0.35;
  for (const k of Object.keys(words)) { const v = Math.abs(traits[k] || 0); if (v > bestV) { bestV = v; best = k; } }
  return best ? words[best][(traits[best] || 0) > 0 ? 1 : 0] : "Plain";
}
